import "../../../static/js/loaders/jquery";

$(".btn-grp button").on('click', function () {
    $(this).toggleClass('selected');
})

$(".submit-button-bottom").on('click', function () {

    $(".btn-grp button").not(document.getElementsByClassName('selected')).children().attr("disabled", true);




})








